import React, { useEffect, useState } from "react";
import { Row, Col, Button, Layout } from "antd";
import "./GetStarted.scss";
import { CALENDLY_LINK } from "../../../env";
import { trackCta } from "../../../analytics";
import { redirectToRegister } from "../../../utils/registerRedirect";
const { Content } = Layout;


const GetStarted = () => {
    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    )

}

const WebVersion = () => {
    const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services`;

    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid get-section-wrapper">
                <Col span={15} className="direction-flex coll justify-in-center">
                    <div className="manrope f-38 w-500 lh-46 mb-20 white text-center">
                        Get started today with ALL3D
                    </div>

                </Col>
                <Col span={24} className="justify-in-center button-section">
                    <Button onClick={() => {
                        trackCta('free_trial_click', {
                            section: 'get_started',
                            placement: 'desktop',
                            button: 'get_started_for_free',
                        });
                        redirectToRegister(redirectPath);
                    }}
                        className={`manrope f-16 w-700 lh-24 blue-button gradient-button`}>
                        Try AI images for free
                    </Button>
                    <Button onClick={() => {
                        trackCta('schedule_demo_click', {
                            section: 'get_started',
                            placement: 'desktop',
                            button: 'schedule_a_demo',
                        });
                        window.open(CALENDLY_LINK, "_blank")
                    }}
                        className={`manrope f-16 w-700 lh-24 transparent-blue-btn ml-16`}>
                        Schedule a 3D demo
                    </Button>
                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {
    const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services`;

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid get-section-wrapper">
                <Col span={24} className="direction-flex coll justify-in-center">
                    <div className="manrope f-30 w-500 lh-40 mb-24 white text-center">
                        Get started today <br />with ALL3D
                    </div>
                </Col>
                <Col span={24}>
                    <Button onClick={() => {
                        trackCta('free_trial_click', {
                            section: 'get_started',
                            placement: 'mobile',
                            button: 'get_started_for_free',
                        });
                        redirectToRegister(redirectPath);
                    }}
                        className={`manrope f-16 w-700 lh-24 w-100 blue-button mb-16 w-100 gradient-button`}>
                        Try AI images for free
                    </Button>
                    <Button onClick={() => {
                        trackCta('schedule_demo_click', {
                            section: 'get_started',
                            placement: 'mobile',
                            button: 'schedule_a_demo',
                        });
                        window.open(CALENDLY_LINK, "_blank")
                    }}
                        className={`manrope f-16 w-700 lh-24 w-100 transparent-blue-btn w-100`}>
                        Schedule a 3D demo
                    </Button>
                </Col>
            </Row>
        </Content>
    );
}

export default GetStarted;
